export const enum EgenskapsTypeEnum {
    ASSOSIASJON = 'Assosiasjon',
    BOOLSK = 'Boolsk',
    BINAER = 'Binær',
    TEKST = 'Tekst',
    DATO = 'Dato',
    FLYTTALL = 'Flyttall',
    HELTALL = 'Heltall',
    STRUKTUR = 'Struktur',
    GEOMETRI = 'Geometri',
    STEDFESTING = 'Stedfesting',
    KORTDATO = 'Kortdato',
    TID = 'Tid',
    LISTE = 'Liste',
    TEKSTENUM = 'Tekstenum',
    HELTALLENUM = 'Heltallenum',
    FLYTTALLENUM = 'Flyttallenum',
}
